import { Component, OnInit } from '@angular/core';
import { CommunicationAgentDTO, DocumentCategories, CompanyDTO, RepresentativeDTO } from '../../../api/plyca-dtos-v2';
import { SearchSettingDTOModal, searchGenericComponent } from '../../../components/search/searchGeneric.component';
import { CommunicationBaseFieldComponent, ChipElement } from './communication.basefield.component';
import { Validators, FormControl } from '@angular/forms';
import { PersonDTO, I18nData } from '../../../api/plyca-dtos';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

@Component({
  selector: 'communication-field-to',
  templateUrl: './communication.field-to.template.html'
})
export class CommunicationFieldToComponent extends CommunicationBaseFieldComponent implements OnInit {

  public chipElements: Array<ChipElement>;

  ngOnInit(): void {
    super.ngOnInit();
    this.reloadChips();
  }

  public manageFocus(event: Event) {
    if (!this.isMailChannel()) {
      this.setFocusToElement(event, 'searchCompanyBtn')
    }
  }

  public isMailChannel(): boolean {
    return this.model.dto.channel && this.model.dto.channel.identifier === 'MAIL';
  }

  public addMail(event: { originalEvent: Event, value: any }): void {
    let emailField = new FormControl();
    emailField.setValue(event.value);
    if (Validators.email(emailField)) {
      this.uiService.showMessage(this.translateService.instant('Communications.detail.form.errors.mailFormat'),
        this.translateService.instant('General.error'));
      this.uiService.cancelEvent(event.originalEvent);
    } else {
      let agent = new CommunicationAgentDTO();
      agent.agentClass = DocumentCategories.Mail;
      agent.email = emailField.value;
      this.addReceiver(agent);
    }
  }

  private addReceiver(agent: CommunicationAgentDTO) {
    let receivers = this.model.dto.receivers;
    let add = true;
    if (!receivers) {
      receivers = [];
      this.model.dto.receivers = receivers;
    } else {
      // validar que no se haya insertado previamente
      add = receivers.find(receiver => CommunicationAgentDTO.sameObject(receiver, agent)) == undefined;
    }
    if (add) {
      receivers.push(agent);
    } else {
      this.uiService.showMessage(new I18nData('Communications.detail.form.errors.receiverExists'), 'General.warning');
    }
    this.reloadChips();
  }

  public onAgentRemove(event: { originalEvent: Event, value: ChipElement }): void {
    let receivers = this.model.dto.receivers.filter((receiver: CommunicationAgentDTO) => receiver !== event.value.value);
    this.model.dto.receivers = receivers;
    this.reloadChips();
  }

  public onAgentClick(event: { originalEvent: Event, value: ChipElement }): void {
  }

  public searchCompany(): void {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('General.search.company'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle',
      closable: false
    };
    config['context'] = new SearchSettingDTOModal('com.nexusit.plyca.admin.interfaz.BuscadorEmpresasRIL');
    this.editDialogOpened.emit(true);
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose,
      (company: CompanyDTO) => {
        if (company) {
          let agent = new CommunicationAgentDTO();
          agent.agentClass = DocumentCategories.Empresa;
          agent.company = company;
          this.addReceiver(agent);
        }
        this.editDialogOpened.emit(false);
      },
      (error) => {
        this.editDialogOpened.emit(false);
        throw error;
      });
  }

  public searchAgent(): void {
    let config: DynamicDialogConfig = {
      header: 'Buscador de representantes',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle',
      closable: false
    };
    config['context'] = new SearchSettingDTOModal('BuscadorRepresentantesRIL2');
    this.editDialogOpened.emit(true);
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose,
      (representative: RepresentativeDTO) => {
        if (representative) {
          let agent = new CommunicationAgentDTO();
          agent.agentClass = DocumentCategories.Empresa;
          agent.company = representative.parent;
          representative.parent = undefined;
          agent.companyAgent = representative;
          this.addReceiver(agent);
        }
        this.editDialogOpened.emit(false);
      },
      (error) => {
        this.editDialogOpened.emit(false);
        throw error;
      });
  }

  public searchPerson(): void {
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('General.search.person'),
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['context'] = new SearchSettingDTOModal('com.nexusit.framework.buscador.interfaz.BuscadorAdmPersonas');
    this.editDialogOpened.emit(true);
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose,
      (person: PersonDTO) => {
        if (person) {
          let agent = new CommunicationAgentDTO();
          agent.agentClass = DocumentCategories.Persona;
          agent.person = person;
          this.addReceiver(agent);
        }
        this.editDialogOpened.emit(false);
      },
      (error) => {
        this.editDialogOpened.emit(false);
        throw error;
      });
  }


  public getAgentListDescription(receivers: CommunicationAgentDTO[]): string {
    return (receivers) ? CommunicationAgentDTO.getAgentListDescription(receivers) : '';
  }

  private reloadChips() {
    this.chipElements = new Array();
    if (this.model.dto.receivers) {
      this.model.dto.receivers.forEach((receiver: CommunicationAgentDTO) => {
        let element = new ChipElement();
        element.name = CommunicationAgentDTO.getAgentDescription(receiver);
        element.value = receiver;
        this.chipElements.push(element);
      });
    }
  }

}